// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*!**/\n/*    Notifications*/\n/* *!*/\n.notifications {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3;\n}\n.notifications .notifications-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  position: relative;\n}\n.notifications .alerts {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  pointer-events: auto;\n}\n.notifications .btn {\n  width: fit-content;\n}\n", ""]);
// Exports
module.exports = exports;
